import SharedSortableTableController from "../../shared/sortable_table_controller";

// Connects to data-controller="administration--role-assignments--sortable-table"
export default class extends SharedSortableTableController {
  getColumnIndex(attribute) {
    const attributeToIndexMap = {
      name: 0,
      email: 1,
      status: 2,
    };

    return attributeToIndexMap[attribute] || 0;
  }
}
